import { Component, signal } from '@angular/core';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ClientListComponent } from '../../../ui/admin/client-list/client-list.component';
import { AngularModule } from '../../../../modules/angular.module';
import { CourseListComponent } from '../../../ui/admin/course-list/course-list.component';
import { UnitListComponent } from '../../../ui/admin/unit-list/unit-list.component';
import { LessonListComponent } from '../../../ui/admin/lesson-list/lesson-list.component';
import { ActivityListComponent } from '../../../ui/admin/activity-list/activity-list.component';
import { ContentListComponent } from '../../../ui/admin/content-list/content-list.component';
import { ClipboardComponent } from '../../../ui/admin/clipboard/clipboard.component';
import { ClientService } from '../../../../services/client.service';
import { AdminService } from '../../../../services/admin.service';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { LocationListComponent } from '../../../ui/admin/location-list/location-list.component';
import { LocationService } from '../../../../services/location.service';
import { Subscription } from 'rxjs';
import { Client, Location, LoginTracking } from '@mira-avant/mtlibs';
import { ClientUserExportComponent } from '../../../ui/admin/client-user-export/client-user-export.component';
import { AuthService } from '../../../../services/auth.service';
import { LoginTrackingListComponent } from '../../../ui/admin/login-tracking-list/login-tracking-list.component';
import { LoginTrackingService } from '../../../../services/login-tracking.service';
import { NavigationService } from '../../../../services/navigation.service';

@Component({
	selector: 'app-lc',
	standalone: true,
	imports: [
		AngularModule,
		ZorroModule,
		ClientListComponent,
		CourseListComponent,
		UnitListComponent,
		LessonListComponent,
		ActivityListComponent,
		ContentListComponent,
		ClipboardComponent,
		BreadcrumbsComponent,
		LocationListComponent,
		ClientUserExportComponent,
		LoginTrackingListComponent,
	],
	templateUrl: './lc.component.html',
	styleUrl: './lc.component.scss',
})
export class LcComponent {
	private sub?: Subscription;

	readonly logins = signal<LoginTracking[]>([]);
	readonly hasLocations = signal<boolean>(false);
	readonly isAdmin = signal<boolean>(false);

	constructor(
		public adminService: AdminService,
		public clientService: ClientService,
		public locationService: LocationService,
		private authService: AuthService,
		private loginTrackingService: LoginTrackingService,
		private nav: NavigationService
	) {
		this.authService.isAdmin$().then((isAdmin: boolean) => {
			this.isAdmin.set(isAdmin);
		});

		this.sub = this.adminService.selectedClient$.subscribe((client: Client | undefined) => {
			if (!client) {
				return;
			}

			this.loginTrackingService.getLastLoginsByClient$(client.uuid).then((logins: LoginTracking[]) => {
				this.logins.set(logins);
			});

			this.locationService.hasLocations(client.uuid).then((hasLocations: boolean) => {
				this.hasLocations.set(hasLocations);
			});
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
